module.exports = __webpack_public_path__ + "img/416.b273504c.png";